import PropTypes from 'prop-types';

import {
    Group,
    Stack,
    Text,
} from '@mantine/core';
import {
    Registration,
    RegistrationDimension,
} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardTimestampFormatter
} from "@flexinet/ui-components";
import {
    RbacGatedProperty,
    useAllowedItems
} from "../../../hooks/useAllowedProperties.ts";

const DimensionsTable = ({dimensions}: { dimensions: RegistrationDimension[] }) => {
    return (
        <>
            {dimensions.map((dimension, index) => (<Stack key={index} gap={'xs'}>
                <Group ml={'1em'} gap={'xs'}><Text
                    fw={600}>Name:</Text><Text>{dimension.name}</Text></Group>
                <Group ml={'1em'} gap={'xs'}><Text
                    fw={600}>Value:</Text><Text>{dimension.value}</Text></Group>
            </Stack>))}
        </>
    );
};

DimensionsTable.propTypes = {
    dimensions: PropTypes.array,
};

export const Profile = ({record}: { record: Registration }) => {

    const properties: RbacGatedProperty[] = [
        {
            label: 'Product Code',
            value: record.productCode as string,
            span: 6,
        }, {
            label: 'Customer Identifier',
            value: record.customerIdentifier as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 6,
        }, {
            label: 'Customer AWS Account ID',
            value: record.customerAWSAccountId as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 6,
        }, {
            label: 'Marketplace Token',
            value: record.marketplaceToken as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 6,
        }, {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateRegistration',
            span: 3,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatter: (value: string) => <PlatformPropertyCardTimestampFormatter value={value}/>,
            span: 3,
        }, {
            label: 'Managed By',
            value: typeof record.managedBy !== 'undefined' && record.managedBy !== null ? [record.managedBy.givenName, record.managedBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateRegistration',
            span: 3,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatter: (value: string) => <PlatformPropertyCardTimestampFormatter value={value}/>,
            span: 3,
        }];

    const {filterAllowed} = useAllowedItems()
    const allowedProperties = filterAllowed(properties);

    return (
        <PlatformPropertyCard properties={allowedProperties}/>
    );


};

Profile.propTypes = {
    record: PropTypes.shape({
                                name: PropTypes.string,
                                description: PropTypes.string,
                                status: PropTypes.string,
                                createdBy: PropTypes.shape({
                                                               givenName: PropTypes.string,
                                                               familyName: PropTypes.string,
                                                           }),
                                managedBy: PropTypes.shape({
                                                               givenName: PropTypes.string,
                                                               familyName: PropTypes.string,
                                                           }),
                                created: PropTypes.string,
                                updated: PropTypes.string,
                            }),
};


